
import { supabase } from "@/lib/supabase";

/**
 * Verify a Turnstile token using Supabase Edge Function
 * @param token The Turnstile token to verify
 * @returns A boolean indicating whether the token is valid
 */
export async function verifyTurnstileToken(token: string): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke('verify-turnstile', {
      body: { token }
    });

    if (error) {
      console.error('Error invoking verify-turnstile function:', error);
      return false;
    }

    return data.success === true;
  } catch (error) {
    console.error('Error verifying Turnstile token:', error);
    return false;
  }
}

/**
 * Utility to log security-related events
 * @param userId The user ID associated with the event
 * @param eventType The type of security event
 * @param description A description of the event
 * @param metadata Additional data related to the event
 */
export async function logSecurityEvent(
  userId: string | null, 
  eventType: string, 
  description: string, 
  metadata: Record<string, any> = {}
): Promise<void> {
  try {
    // Add IP and user agent info to metadata
    const enhancedMetadata = {
      ...metadata,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    await supabase.from('security_logs').insert({
      user_id: userId,
      event_type: eventType,
      description,
      ip_address: null, // We can't get the actual IP on the client side
      user_agent: navigator.userAgent,
      metadata: enhancedMetadata
    });
  } catch (error) {
    console.error('Failed to log security event:', error);
  }
}
